import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BreadCrumbWrapper = styled.div.withConfig({
  displayName: "layoutBreadCrumb__BreadCrumbWrapper",
  componentId: "sc-1tgxq8e-0"
})(["position:relative;width:100%;&::after{content:'';position:absolute;left:-24px;right:-24px;bottom:0;}"]);
var StyledBreadCrumb = styled.nav.withConfig({
  displayName: "layoutBreadCrumb__StyledBreadCrumb",
  componentId: "sc-1tgxq8e-1"
})(["display:flex;align-items:center;gap:8px;color:rgba(0,0,0,0.45);font-size:14px;line-height:30px;"]);
var RootText = styled.span.withConfig({
  displayName: "layoutBreadCrumb__RootText",
  componentId: "sc-1tgxq8e-2"
})(["color:rgba(0,0,0,0.45);"]);
var Separator = styled.span.withConfig({
  displayName: "layoutBreadCrumb__Separator",
  componentId: "sc-1tgxq8e-3"
})(["color:rgba(0,0,0,0.35);"]);
var CurrentText = styled.span.withConfig({
  displayName: "layoutBreadCrumb__CurrentText",
  componentId: "sc-1tgxq8e-4"
})(["color:rgba(0,0,0,0.88);font-weight:600;"]);

var normalizeLabel = function normalizeLabel(value) {
  return decodeURIComponent(value).replace(/[-_]+/g, ' ').replace(/\b\w/g, function (_char) {
    return _char.toUpperCase();
  });
};

var resolveCurrentSegment = function resolveCurrentSegment(url) {
  if (!url) return '';

  try {
    var parsedUrl = new URL(url, 'http://localhost');
    var tabFromQuery = parsedUrl.searchParams.get('tab');
    if (tabFromQuery) return tabFromQuery;
    var pathSegments = parsedUrl.pathname.split('/').filter(Boolean);
    return pathSegments[pathSegments.length - 1] || '';
  } catch (_unused) {
    var cleanUrl = url.split(/[?#]/)[0] || '';

    var _pathSegments = cleanUrl.split('/').filter(Boolean);

    return _pathSegments[_pathSegments.length - 1] || '';
  }
};

export var LayoutBreadCrumb = function LayoutBreadCrumb(_ref) {
  var root = _ref.root,
      url = _ref.url;
  var currentSegment = resolveCurrentSegment(url);
  var currentLabel = normalizeLabel(currentSegment);

  if (!currentLabel) {
    return /*#__PURE__*/_jsx(BreadCrumbWrapper, {
      children: /*#__PURE__*/_jsx(StyledBreadCrumb, {
        "aria-label": "Breadcrumb",
        children: /*#__PURE__*/_jsx(RootText, {
          children: root
        })
      })
    });
  }

  return /*#__PURE__*/_jsx(BreadCrumbWrapper, {
    children: /*#__PURE__*/_jsxs(StyledBreadCrumb, {
      "aria-label": "Breadcrumb",
      children: [/*#__PURE__*/_jsx(RootText, {
        children: root
      }), /*#__PURE__*/_jsx(Separator, {
        children: "/"
      }), /*#__PURE__*/_jsx(CurrentText, {
        children: currentLabel
      })]
    })
  });
};
LayoutBreadCrumb.displayName = 'LayoutBreadCrumb';